<template>
    <div :class="container">
        <div :class="studentInfo" style="vertical-align: middle">
            <div class="term-panel">
                <!-- <span class="term-select-label">semester：</span> -->
                <!-- <SemesterSelector class="semester-select" v-model="semesterId"></SemesterSelector> -->
            </div>
            <div class="student-info-panel">
                <div class="header-image-panel" v-if="studentAvatar">
                    <!-- <img :src="studentAvatar" class="header-image" @click="goToStudentInfo()" /> -->
                    <img :src="studentAvatar" class="header-image" @click="avatarDialog = true" />
                </div>
                <div class="header-image-panel" v-else>
                    <img src="../assets/images/ze-contact.png" class="header-image1" @click="goToStudentInfo()" />
                </div>

                <div class="info-panel">
                    <div class="student-name">
                        <div>{{ $t('Student') }}：{{ student.name }}</div>
                        <div class="change-student" @click="showStudentList = true" v-if="studentList.length > 1">{{ $t('Other Students') }}</div>
                        <div class="change-student" @click="addStudent" v-if="studentList.length == 0">{{ $t('Add Student') }}</div>
                    </div>
                    <div class="student-birthday">
                        <div>{{ $t('NO') }}：{{ student.id ? student.id : '' }}</div>
                        <div>{{ $t('Birthday') }}：{{ student.idNO ? student.idNO.substring(6, 6+8) : '' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="first-enter-panel">
            <div class="first-enter" @click="goToGuildLine()">
                <div class="first-enter-icon">
                    <el-icon :size="iconSize" color="#8ACF55">
                        <Document />
                    </el-icon>
                </div>
                <p>{{ $t('GuildLine') }}</p>
            </div>
            <div class="first-enter" @click="goToNotice()">
                <div class="first-enter-icon">
                    <el-badge :value="unreadCnt" class="badge" :hidden="unreadCnt === 0">
                        <el-icon :size="iconSize" color="#E6A49F">
                            <ChatDotSquare />
                        </el-icon>
                    </el-badge>
                </div>
                <p>{{ $t('Notice') }}</p>
            </div>
        </div>
        <div class="enter-panal">
            <div class="function-container" v-if="show == 'false'">
                <!-- Class Registration Section -->
                <div class="function-group">
                    <div class="function-group-title">{{ $t('Enrolling') }}</div>
                    <div class="second-enter" @click="goToMyCourse()">
                        <div class="second-enter-icon">
                            <!-- <img :src="require('../assets/images/1-3.png')" alt /> -->
                            <el-icon :size="iconSize" color="#409EFF">
                                <Files />
                            </el-icon>
                        </div>
                        <p>{{ $t('All Courses') }}</p>
                    </div>
                    <div class="second-enter" @click="goToSignup()">
                        <div class="second-enter-icon">
                            <el-icon :size="iconSize" color="#409EFF">
                                <DocumentAdd />
                            </el-icon>
                        </div>
                        <p>{{ $t('Signed Up') }}</p>
                    </div>
                    <div class="second-enter" @click="goToPayPending()">
                        <div class="second-enter-icon">
                            <el-icon :size="iconSize" color="#FF7B74">
                                <Tickets />
                            </el-icon>
                        </div>
                        <p>{{ $t('Pay Pending') }}</p>
                    </div>
                    <div class="second-enter" @click="goToPaid()">
                        <div class="second-enter-icon">
                            <el-icon :size="iconSize" color="#8ACF55">
                                <Document />
                            </el-icon>
                        </div>
                        <p>{{ $t('Paid') }}</p>
                    </div>
                </div>

                <div class="function-group">
                    <div class="function-group-title">{{ $t('Photo') }}</div>
                    <div v-for="item in paidList" :key="item.id" class="second-enter" @click="goToCoursePhoto(item.courseId, item.courseName)">
                        <div class="second-enter-icon">
                            <!-- <img :src="require('../assets/images/1-3.png')" alt /> -->
                            <el-icon :size="iconSize" color="var(--el-color-warning)">
                                <Picture />
                            </el-icon>
                        </div>
                        <p>{{ item.courseName }}</p>
                    </div>
                </div>

                <!-- Home-School Communication Section -->
                <div class="function-group" v-if="false">
                    <div class="function-group-title">{{ $t('Communication') }}</div>
                    <div class="second-enter" v-for="item in [
                        { id: '12', name: '课堂风采', img: require('../assets/images/2-1.png'), path: '/ClassPresence', params: ['org_id', 'role_type', 'termId', 'clearCount'] },
                        { id: '17', name: '班级作业', img: require('../assets/images/2-5.png'), path: '/StudentHomeworkIndex', params: ['org_id', 'termId'] },
                        { id: '14', name: '班级通知', img: require('../assets/svg/2-2.svg'), path: '/StudentNotice', params: ['org_id', 'termId'] },
                        { id: '22', name: '班级群', img: require('../assets/images/2-8.png'), path: '4', params: [] },
                        { id: '15', name: '联系老师', img: require('../assets/svg/2-3.svg'), path: '/StudentMessage', params: ['org_id', 'termId'] },
                        { id: '16', name: '课堂评价', img: require('../assets/svg/2-4.svg'), path: '/StudentRate', params: ['org_id', 'termId'] },
                        { id: '19', name: '家长评价教师', img: require('../assets/images/2-7.png'), path: '/SurveyList', params: ['org_id', 'termId', 'surveyType'] },
                        { id: '99', name: '班级活动', img: require('../assets/images/classActivity.png'), path: '5', params: ['org_id'] },
                        { id: '18', name: '查看未填问卷', img: require('../assets/images/2-6.png'), path: '/QuestionnaireHome', params: ['org_id', 'termId', 'type0'] }
                    ]" :key="item.id" @click="openMenu(item.path, item.params)">
                        <div class="second-enter-icon">
                            <el-badge :count="count" v-if="item.name === '课堂风采'" class="demo-badge">
                                <img :src="item.img" alt />
                            </el-badge>
                            <el-badge :count="noticeCount" v-else-if="item.name === '班级通知'" class="demo-badge">
                                <img :src="item.img" alt />
                            </el-badge>
                            <el-badge :count="questionnaireCount" v-else-if="item.name === '查看未填问卷'" class="demo-badge">
                                <img :src="item.img" alt />
                            </el-badge>
                            <el-badge :count="imCount" v-else-if="item.name === '班级群'" class="demo-badge">
                                <img :src="item.img" alt />
                            </el-badge>
                            <el-badge :count="homeWorkCount" v-else-if="item.name === '班级作业'" class="demo-badge">
                                <img :src="item.img" alt />
                            </el-badge>
                            <el-badge :count="contactTeacherCount" v-else-if="item.name === '联系老师'" class="demo-badge">
                                <img :src="item.img" alt />
                            </el-badge>
                            <img :src="item.img" alt v-else />
                        </div>
                        <p>{{ item.name }}</p>
                    </div>
                </div>

                <!-- Class Attendance Section -->
                <div class="function-group">
                    <div class="function-group-title">{{ $t('Attending') }}</div>
                    <div class="second-enter" @click="gotoAttendance()">
                        <div class="second-enter-icon">
                            <!-- <img :src="require('../assets/images/3-1.png')" alt /> -->
                            <el-icon :size="iconSize" color="#409EFF">
                                <User />
                            </el-icon>
                        </div>
                        <p>{{ $t('All') }}</p>
                    </div>
                    <div class="second-enter" @click="attendanceToday()">
                        <div class="second-enter-icon">
                            <!-- <img :src="require('../assets/images/3-1.png')" alt /> -->
                            <el-icon :size="iconSize" color="#FF4D4F">
                                <Calendar />
                            </el-icon>
                        </div>
                        <p>{{ $t('Today') }}</p>
                    </div>
                </div>

                <!-- Student Information Section -->
                <div class="function-group">
                    <div class="function-group-title">{{ $t('Information') }}</div>
                    <div class="second-enter" @click="goToParentInfo()">
                        <div class="second-enter-icon">
                            <el-icon :size="iconSize" color="#87CEEB">
                                <InfoFilled />
                            </el-icon>
                        </div>
                        <p>{{ $t('Me') }}</p>
                    </div>
                    <div class="second-enter" @click="goToStudentInfo()">
                        <div class="second-enter-icon">
                            <el-icon :size="iconSize" color="#8ACF55">
                                <InfoFilled />
                            </el-icon>
                        </div>
                        <p>{{ $t('Student') }}</p>
                    </div>
                    <div class="second-enter" @click="switchLanguage()">
                        <div class="second-enter-icon">
                            <el-icon :size="iconSize" color="#8ACF55">
                                <SetUp/>
                            </el-icon>
                        </div>
                        <p>{{ currentLanguage }}</p>
                    </div>
                    <div class="second-enter" @click="logout()">
                        <div class="second-enter-icon">
                            <el-icon :size="iconSize" color="#FF4D4F">
                                <Lock />
                            </el-icon>
                        </div>
                        <p>{{ $t('Logout') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog v-model="showStudentList" :title="$t('Choose Student')">
            <div v-for="student in studentList" :key="student.id" @click="selectStudent(student)">
                <el-radio v-model="selectedStudentId" :label="student.id">
                    <div>{{ $t('Student') }}：{{ student.name }}</div>
                    <!-- <div>NO：{{ student.number ? student.number : '' }}</div> -->
                    <!-- <div>birthday：{{ student.birthday ? student.birthday.substring(0, 10) : '' }}</div> -->
                </el-radio>
            </div>
        </el-dialog>
        <PhotoDialog v-model="avatarDialog" :src="studentAvatar" />
    </div>

</template>
<script>
import axios from "axios";
// import SemesterSelector from "@/components/SemesterSelector.vue";
import { BACKEND_URL } from '../../../share-source/src/config/config.js'
import { useUserStore } from "@/stores/Global";
import { Document, ChatDotSquare, User, Files, InfoFilled, Tickets, DocumentAdd, Calendar, Lock, Picture, SetUp } from '@element-plus/icons-vue'
import { SignupStatus } from "@/constants/SignupStatus";
import PhotoDialog from '../../../share-source/src/components/PhotoDialog.vue';

export default {
    components: {
        // SemesterSelector,
        Document,
        ChatDotSquare,
        User,
        Files,
        InfoFilled,
        Tickets,
        DocumentAdd,
        Calendar,
        Lock,
        Picture,
        SetUp,
        PhotoDialog
    },
    setup() {
        const userStore = useUserStore();
        return {
            userStore
        }
    },
    name: "WechatStudentIndex",
    data() {
        return {
            student: {},
            studentList: [],
            showStudentList: false,
            selectedStudentId: '',
            semesterId: '',
            count: 0,
            studentInfo: "studentInfo",
            container: "container",
            orgId: new URLSearchParams(location.search).get("org_id")
                ? new URLSearchParams(location.search).get("org_id")
                : "344",
            show: 'false',
            noticeCount: 0,
            questionnaireCount: 0,
            imCount: 0,
            contactTeacherCount: 0,
            homeWorkCount: 0,
            iconSize: 40,
            avatarDialog: false,
            paidList: [],
            unreadCnt: 0
        };
    },
    computed: {
        studentAvatar() {
            if (this.student.avatar) {
                return `${BACKEND_URL}${this.student.avatar}`;
            }
            return null;
        },
        currentLanguage() {
            return this.$i18n.locale !== 'zh' ? '中文' : 'English';
        },
    },
    watch: {
        selectedStudentId: {
            // eslint-disable-next-line no-unused-vars
            handler(newVal) {
                // console.log("selectedStudentId in watch: ", newVal)
                this.fetchPhotoCourseList();
                this.fetchUnreadNoticeCnt(newVal);
            },
        }
    },
    async created() {
        // await this.getNoticeData();

    },
    mounted: function () {
        this.fetchStudentList();
        // this.fetchPhotoCourseList();
    },
    methods: {
        switchLanguage() {
            this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
            localStorage.setItem('locale', this.$i18n.locale)
        },
        goToCoursePhoto(courseId, courseName) {
            this.$router.push({ name: 'CoursePhoto', params: { id: courseId, name: courseName } });
        },
        goToParentInfo() {
            this.$router.push({ name: 'ParentInfo', params: { id: this.userStore.getUserId() } });
        },
        attendanceToday() {
            // const today = new Date().toISOString().split('T')[0];
            this.$router.push({ name: 'MyAttendance', params: { student_id: this.student.id, date: new Date()} });
        },
        goToSignup() {
            this.$router.push({ name: 'MyCourse', params: { status: SignupStatus.SIGNED_UP } });
        },
        goToPayPending() {
            this.$router.push({ name: 'MyCourse', params: { status: SignupStatus.PAYABLE } });
        },
        goToPaid() {
            this.$router.push({ name: 'MyCourse', params: { status: SignupStatus.PAID } });
        },      
        logout() {
            this.$router.push({ name: 'BackendLogout' });
        },
        goToStudentInfo() {
            if (this.student.id) {
                this.$router.push({ name: 'StudentInfo', params: { id: this.student.id } });
            } else {
                this.$message.error('no student selected, should add and bind one.');
            }
        },
        async addStudent() {
            await this.fetchStudentList();
            if (this.studentList.length == 0) {
                this.$router.push({ name: 'StudentInfo' });
            }
        },
        goToGuildLine() {
            this.$router.push({ name: 'GuildLine' });
        },
        goToNotice() {
            this.$router.push({ name: 'Notice' });
        },
        selectStudent(student) {
            this.student = student;
            this.showStudentList = false;
            this.userStore.setStudentId(student.id);
        },  
        async fetchStudentList() {
            await axios.get(`${BACKEND_URL}/api/student/my`).then(rsp => {
                this.studentList = rsp.data;
                if (this.studentList.length == 0) {
                    this.$message.error('found no student.');
                    return;
                }
                // console.log('studentList', this.studentList);
                const studentId = this.userStore.getStudentId();    
                this.student = this.studentList.find(student => student.id === parseInt(studentId));
                if (!this.student) {
                    this.student = this.studentList[0];
                    this.selectedStudentId = this.student.id;
                    if (this.student) {
                        this.userStore.setStudentId(this.student.id);
                    }
                } else {
                    this.selectedStudentId = this.student.id;
                }   
            }).catch(error => {
                this.$message.error('fetching student error.');
                console.log('error', error);
            });
        },

        fetchPhotoCourseList() {
            let params = new URLSearchParams();
            params.append('status', SignupStatus.PAID);
            axios.get(`${BACKEND_URL}/api/signup/student/${this.userStore.getStudentId()}`, { params }).then(rsp => {
                this.paidList = rsp.data;
            });
        },

        fetchUnreadNoticeCnt(studentId) {
            console.assert(studentId != 0);

            let params = new URLSearchParams();
            params.append('studentId', studentId)
            params.append('since', this.userStore.getNoticeSince(studentId));

            axios.get(`${BACKEND_URL}/api/notice/unreadcount`, {params}).then(rsp => {
                this.unreadCnt = rsp.data;
                this.userStore.setNoticeSince(studentId, new Date());
            }).catch(err => {
                console.error(err);
            });
        },

        goToMyCourse() {
            this.$router.push({name: 'MyCourse'})
        },  

        gotoAttendance() {
            this.$router.push({ path: '/my-attendance/' + this.student.id });
        },

    },
};
</script>
<style>
.ivu-btn-primary {
    background-color: #8ACF55 !important;
    border-color: #8ACF55 !important;
}

.container .ivu-btn-primary {
    color: #fff;
    background-color: #8ACF55;
    border-color: #8ACF55;
    display: flex;
    flex-direction: column;
}

.red-bg .introjs-tooltipbuttons {
    padding: 5px !important;
    border-top: 0 !important;
}

.red-bg .introjs-button {
    padding: 0.3rem 0.5rem;
    text-shadow: none;
    border-radius: 12px;
    background: #8ACF55;
    color: white;
    box-shadow: none;
    border: none;
}

.ms-mobile-select .ms-ensure {
    color: #8acf55 !important;
}
</style>
<style scoped>
html body {
    width: 100%;
    height: 100%;
    padding-bottom: 20px;
    background-color: #f2f3f7;
}

.container {
    overflow-y: auto;
    position: relative;
    /* display: flex;
    flex-direction: column; */
    background-color: #f2f3f7;
}

.first-enter-icon img {
    width: 30px;
    height: 30px;
    margin-bottom: 4px;
}

.first-enter p {
    font-size: 13px;
    color: #444;
    text-align: center;
    margin-top: 4px;
    margin-bottom: 4px;
}

.second-enter-icon img {
    width: 34px;
    height: 34px;
}

.second-enter p {
    font-size: 12px;
    color: #000;
    text-align: center;
    margin-top: 4px;
    margin-bottom: 4px;
}

.notice-panel {
    position: absolute;
    top: 0;
    width: 100%;
    margin: 0 auto;
    background-color: #fcf3c8;
    color: #f19e54;
    text-align: center;
    font-size: 12px;
    /* padding-top: 4px; */
    padding-bottom: 2px;
    background-image: url('../assets/images/notice_icon.png');
    background-repeat: no-repeat;
    background-position: 3% center;
    background-size: 16px;
}

.notice-content {
    width: 98%;
    text-align: left;
    padding-left: 10%;
    background: url('../assets/images/notice_next.png') no-repeat right center;
    background-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.studentInfo {
    /*background: linear-gradient(266deg, #5c80f2, #3e6bf6, #2d5ff6);*/
    /* background-color: #82cf55; */
    background-color: #557ccf;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    /* justify-content: center;
    align-items: center; */
}

.studentInfo .term-panel {
    padding-top: 26px;
    width: 94%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: left;
    /* align-items: center; */
}

.studentInfo .term-select-label {
    /* width: 22%; */
    /* display: inline-block; */
    color: #ffffff;
    font-size: 14px;
    text-align: right;
    /* flex: 1; */
    height: 30px;
    padding-top: 6px;
}

.semester-select {
    flex: 1;
}

.studentInfo .select-panel {
    width: 77%;
    display: inline-block;
    position: relative;
}

.studentInfo .term-select {
    width: 100%;
    background-color: #f5f5f5;
    height: 30px;
    line-height: 26px;
    border-radius: 10px;
    color: #000;
    font-size: 14px;
    padding: 3px 14px;
}

.studentInfo .open-select {
    background: url("../assets/images/gray_down.png") no-repeat center center;
    background-size: 14px;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 6px;
}

.studentInfo .ivu-select-selection {
    background: #6386f5;
    height: 36px;
    line-height: 36px;
    border-radius: 18px;
    color: #ffffff;
    font-size: 14px;
    border: none;
    outline: none;
    box-shadow: none;
}

.studentInfo .ivu-select-single .ivu-select-selection {
    height: 32px;
    position: relative;
}

.studentInfo .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    color: #ffffff;
}

.studentInfo .ivu-select-arrow {
    color: #ffffff;
}

.student-info-panel {
    position: relative;
    background: rgba(242, 243, 247, 0.2);
    margin-bottom: 15px;
    /* width: 92%; */
    border-radius: 5px;
    padding: 10px 14px 4px 14px;
    display: flex;
    align-items: center;
}

.student-info-panel .header-image-panel {
    /*display: inline-block;*/
    /*width: 25%;*/
    /*text-align: center;*/
    /*vertical-align: middle;*/
    margin-right: 8px;
}

.student-info-panel .header-image-panel .header-image {
    width: 77px;
    height: 77px;
    /* padding: 10.5px; */
    /* border-radius: 100%; */
    margin: 0;
    object-fit: contain;
}

.student-info-panel .header-image-panel .header-image1 {
    width: 56px;
    height: 56px;
    padding: 10.5px;
    /* border-radius: 100%; */
    background-color: #fff;
    border: 1px solid rgb(187, 187, 187);
    margin: 0;
    object-fit: contain;
}

.student-info-panel .info-panel {
    display: inline-block;
    width: 78%;
    color: #ffffff;
}

.info-panel .student-name {
    font-size: 12px;
    height: 20px;
    line-height: 18px;
    margin-bottom: 8px;
    padding-top: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info-panel .student-birthday {
    font-size: 12px;
    height: 22px;
    display: flex;
    justify-content: space-between;
    line-height: 19px;
    white-space: nowrap;
}

.info-panel .student-identify {
    font-size: 9px;
    color: #a5bbfc;
    height: 18px;
    line-height: 18px;
}

.info-panel .student-identify div {
    float: left;
    /* width: 38%; */
    text-align: left;
    padding: 0 8px;
    margin-right: 10px;
    height: 16px;
    border-radius: 8px;
}

.info-panel .student-identify .head-bind.pass {
    padding: 0;
    border: none;
}

.info-panel .student-identify .head-bind.pass .pass-icon {
    background: url("../assets/images/head-bind.png") no-repeat left center;
    background-size: 14px;
    vertical-align: middle;
    width: 17px;
    height: 14px;
    display: inline-block;
}

.info-panel .student-identify .head-bind.unpass {
    background-color: #ffffff;
    color: #5f7ef5;
}

.info-panel .student-identify .head-bind.unpass .unpass-icon {
    background: url("../assets/images/unpass_icon.png") no-repeat left center;
    background-size: 10px;
    vertical-align: middle;
    width: 13px;
    height: 14px;
    display: inline-block;
}

.info-panel .student-identify .idcard-bind.pass {
    padding: 0;
    border: none;
}

.info-panel .student-identify .idcard-bind.pass .pass-icon {
    background: url("../assets/images/idcard-bind.png") no-repeat left center;
    background-size: 14px;
    vertical-align: middle;
    width: 17px;
    height: 14px;
    display: inline-block;
}

.info-panel .student-identify .idcard-bind.unpass {
    background-color: #ffffff;
    color: #5f7ef5;
}

.info-panel .student-identify .idcard-bind.unpass .unpass-icon {
    background: url("../assets/images/unpass_icon.png") no-repeat left center;
    background-size: 10px;
    vertical-align: middle;
    width: 13px;
    height: 14px;
    display: inline-block;
}

.student-info-panel .change-student {
    background: #f2f3f7;
    /*display: inline-block;*/
    padding: 4px 13px;
    border-radius: 4px;
    /*position: absolute;*/
    /*right: 5%;*/
    /*top: 17%;*/
    color: #69cbc8;
    font-size: 12px;
}

.enter-panal {
    /* position: absolute; */
    background-color: #f2f3f7;
    width: 100%;
    /* margin-top: -40px; */
    padding-top: 40px;
    position: relative;
    z-index: 1;
}

.first-enter-panel {
    height: 60px;
    /* top: 156px; */
    top: 116px;
    width: 92%;
    background: #ffffff;
    border-radius: 20px;
    margin: 15px 4%;
    display: flex;
    padding: 12px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: absolute;
    z-index: 999;
}

.first-enter {
    flex: 1;
}

.first-enter-icon {
    text-align: center;
}

.function-container {
    width: 100%;
    padding-bottom: 10px;
    /* margin-bottom: 80px; */
    /* margin-top: 65px; */
}

.function-container .function-group {
    width: 92%;
    background: #ffffff;
    border-radius: 20px;
    margin: 15px 4%;
    overflow: hidden;
    padding-bottom: 10px;
}

.function-container .function-group .function-group-title {
    width: 90%;
    margin-left: 5%;
    color: #000;
    font-size: 14px;
    padding: 15px 0 10px 0;
    border-bottom: 1px solid #e1e1e1;
    margin-bottom: 10px;
}

.second-enter {
    float: left;
    width: 25%;
    margin-bottom: 10px;
}

.second-enter-icon {
    text-align: center;
}

/* .badge {
    margin-top: 10px;
    margin-right: 30px;
} */

[v-cloak] {
    display: none;
}
</style>
